import * as types from '../constants';

export function loadAPIAccess(mine_only = false) {
  return {
    type: types.LOAD_API_ACCESS,
    mine_only,
  };
}

export function createAPIAccess(data) {
  return {
    type: types.CREATE_API_ACCESS,
    data,
  };
}

export function updateAPIAccess(data, uuid) {
  return {
    type: types.UPDATE_API_ACCESS,
    data,
    uuid,
  };
}

export function deleteAPIAccess(data) {
  return {
    type: types.DELETE_API_ACCESS,
    data,
  };
}
